import type { BrandConfig } from './types';
import finch from './brands/finch.json';
import voxli from './brands/voxli.json';

/**
 * Every brand this code knows, by id. Retiring a brand = deleting its data
 * file, its asset folder and its line here.
 */
export const BRANDS: Readonly<Record<string, BrandConfig>> = {
  finch: finch as BrandConfig,
  voxli: voxli as BrandConfig,
};

export const KNOWN_BRAND_IDS: readonly string[] = Object.keys(BRANDS);
